import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";

const KW_RED = "#E50000";

// Stable references — extracted to module level to avoid creating new objects on every render.
// (Recharts compares props by reference; inline objects force unnecessary chart re-renders.)
const CHART_MARGIN = { top: 10, right: 20, left: -10, bottom: 0 };
const AXIS_TICK = { fontSize: 11 };
const TOOLTIP_CONTENT_STYLE = { background: "#0A0A0A", border: "1px solid #222", borderRadius: 2 };
const TOOLTIP_LABEL_STYLE = { color: "#A3A3A3", textTransform: "uppercase", letterSpacing: "0.1em", fontSize: 11 };
const TOOLTIP_ITEM_STYLE = { color: "#fff", fontSize: 12 };
const LEGEND_WRAPPER_STYLE = { fontSize: 11, textTransform: "uppercase", letterSpacing: "0.1em", color: "#A3A3A3" };
const DOT_SMALL = { r: 3, strokeWidth: 0 };
const DOT_R3 = { r: 3 };
const DOT_R4 = { r: 4 };
const ACTIVE_DOT_R5 = { r: 5 };
const PALETTE = [KW_RED, "#A855F7", "#22C55E", "#3B82F6", "#EAB308", "#F97316", "#EC4899", "#06B6D4"];

export function EvolutionLine({ series, dataKey = "cumulative", height = 280 }) {
  // series: [{ name, weekly: [{week, cumulative, points}] }, ...]
  if (!series || series.length === 0) {
    return <div className="text-[#737373] text-sm py-12 text-center">Sem dados ainda. Regista a primeira semana para ver a evolução.</div>;
  }
  // Build merged dataset: [{ week, [player_id]: value, ... }]
  const weeks = series[0].weekly.map((w) => w.week);
  const data = weeks.map((w) => {
    const row = { week: `S${w}` };
    series.forEach((s) => {
      const k = s.player_id || s.name;
      const e = s.weekly.find((x) => x.week === w);
      row[k] = e ? e[dataKey] : 0;
    });
    return row;
  });

  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data} margin={CHART_MARGIN}>
        <CartesianGrid stroke="#1F1F1F" strokeDasharray="2 4" />
        <XAxis dataKey="week" stroke="#737373" tick={AXIS_TICK} />
        <YAxis stroke="#737373" tick={AXIS_TICK} />
        <Tooltip
          contentStyle={TOOLTIP_CONTENT_STYLE}
          labelStyle={TOOLTIP_LABEL_STYLE}
          itemStyle={TOOLTIP_ITEM_STYLE}
        />
        <Legend wrapperStyle={LEGEND_WRAPPER_STYLE} />
        {series.map((s, i) => {
          const k = s.player_id || s.name;
          return (
            <Line
              key={k}
              type="monotone"
              dataKey={k}
              name={s.name}
              stroke={PALETTE[i % PALETTE.length]}
              strokeWidth={2}
              dot={DOT_SMALL}
              activeDot={ACTIVE_DOT_R5}
            />
          );
        })}
      </LineChart>
    </ResponsiveContainer>
  );
}

export function PersonalEvolution({ weekly, height = 240 }) {
  if (!weekly || weekly.length === 0) return <div className="text-[#737373] text-sm py-8 text-center">Sem dados ainda.</div>;
  const data = weekly.map((w) => ({ week: `S${w.week}`, Pontos: w.points, Acumulado: w.cumulative }));
  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data} margin={CHART_MARGIN}>
        <CartesianGrid stroke="#1F1F1F" strokeDasharray="2 4" />
        <XAxis dataKey="week" stroke="#737373" tick={AXIS_TICK} />
        <YAxis stroke="#737373" tick={AXIS_TICK} />
        <Tooltip
          contentStyle={TOOLTIP_CONTENT_STYLE}
          labelStyle={TOOLTIP_LABEL_STYLE}
          itemStyle={TOOLTIP_ITEM_STYLE}
        />
        <Legend wrapperStyle={LEGEND_WRAPPER_STYLE} />
        <Line type="monotone" dataKey="Pontos" stroke="#A3A3A3" strokeWidth={2} dot={DOT_R3} />
        <Line type="monotone" dataKey="Acumulado" stroke={KW_RED} strokeWidth={3} dot={DOT_R4} />
      </LineChart>
    </ResponsiveContainer>
  );
}
